export const LangString = {
  customizeLayout: '自定义布局',
  togglePanel: '切换面板',
  togglePrimarySideBar: '切换主侧栏',
  toggleSecondarySideBar: '切换辅助侧栏',
  primarySideBar: '主侧栏',
  secondarySideBar: '辅助侧栏',
  panel: '面板',
  alignPanel: '对齐面板',
  menuBar: '菜单栏',
  activityBar: '活动栏',
  statusBar: '状态栏',
  left: '左对齐',
  right: '右对齐',
  center: '居中',
  justify: '两端对齐',
  primarySideBarPosition: '主侧栏位置',
  panelAlignment: '面板对齐方式',
  visibility: '可见性',
  restoreDefault: '还原默认值',
  close: '关闭',
  hide: '隐藏',
  hidden: '隐藏',
  show: '显示',
  side: '侧边',
  top: '顶部',
  badge: '徽章',
  additionalViews: '额外视图',
  activityBarPosition: '活动栏位置',
  movePrimarySideBarRight: '向右移动主侧栏',
  movePrimarySideBarLeft: '向左移动主侧栏',
  moveSecondarySideBarRight: '向右移动辅助侧栏',
  moveSecondarySideBarLeft: '向左移动辅助侧栏',
  hideSecondarySideBar: '隐藏辅助侧栏',
  hidePanel: '隐藏面板',
  maximizePanel: '最大化面板大小',
  restorePanelSize: '恢复面板大小',
};